import './Loading.css';
import { FaSpinner as Spinner } from 'react-icons/lib/fa';
import React from 'react';

const Loading = ({ size }) => (
  <div className="Loading">
    <Spinner size={size} />
  </div>
);

export default Loading;
